(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector/assets/javascripts/account-selector-error.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector/assets/javascripts/account-selector-error.js'); 
'use strict';

const {
  errors: {
    UNKNOWN
  },
  errorMessages
} = svs.numbergames.accountSelector.constants;
class AccountSelectorError extends Error {
  constructor() {
    let {
      type = UNKNOWN,
      message = errorMessages[UNKNOWN]
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    this.type = type;
    this.message = message;
  }
}
svs.numbergames.accountSelector.AccountSelectorError = AccountSelectorError;
 })(window);